/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Desc_Cc_Move_Down_One_LineInputs */



/**
* | output |
* | --- |
* | "Move the Event position down 1 line" |
*
* @param {Shortcut_Keys_Desc_Cc_Move_Down_One_LineInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_desc_cc_move_down_one_line = /** @type {((inputs?: Shortcut_Keys_Desc_Cc_Move_Down_One_LineInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Desc_Cc_Move_Down_One_LineInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Deplacer la position de l'evenement d'une ligne vers le bas")
	if (locale === "de") return /** @type {LocalizedString} */ ("Verschieben Sie die Ereignisposition um eine Zeile nach unten.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Sposta la posizione dell'evento di 1 riga verso il basso")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Переместите позицию события на одну строку вниз.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Mueva la posición del evento hacia abajo 1 línea")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("将事件位置向下移动一行")
	if (locale === "ja") return /** @type {LocalizedString} */ ("イベントの位置を1行下に移動します")
	if (locale === "hi") return /** @type {LocalizedString} */ ("इवेंट की स्थिति को 1 पंक्ति नीचे ले जाएं")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Desloque a posição do evento uma linha para baixo.")
	return /** @type {LocalizedString} */ ("Move the Event position down 1 line")
});